export default __webpack_public_path__ + "static/img6-30b371e595b8f53b4d2f362e8310f8bb.jpg";